import React from "react";

export type BookingIdProps = {
  id: string;
}

export const BookingId: React.FC<BookingIdProps> = ({ id }) => {
  return <span>#{id.substring(id.length - 5)}</span>
}
